import React, { ReactNode } from 'react'
import tw from 'twin.macro'
import { Card, TuneIcon } from '@nominex/dex-uikit'
import { SlBadge } from '@shoelace-style/shoelace/dist/react'
import GlobalSettings from 'components/Menu/GlobalSettings'
import { useExpertModeManager } from 'state/user/hooks'
import AppNavTabs from './AppNavTabs'
import Transactions from './Transactions'

export const BodyWrapper = tw(Card)`
  max-w-[570px] w-full z-[1]
`

interface Props {
  noConfig?: boolean
  children: ReactNode
}

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
const AppBody: React.FC<Props> = ({ children, noConfig = false }) => {
  const [expertMode] = useExpertModeManager()

  return (
    <BodyWrapper isActive>
      <div className="flex flex-col p-24 md:py-24 md:px-32">
        <div className="flex items-center justify-between">
          <AppNavTabs />
          <div className="flex items-center">
            {!noConfig && (
              <div className="relative">
                <GlobalSettings IconComponent={TuneIcon} />
                {expertMode && <SlBadge variant="danger" className="dot absolute right-0 top-0" />}
              </div>
            )}
            <Transactions />
          </div>
        </div>
        {children}
      </div>
    </BodyWrapper>
  )
}

export default AppBody
